"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconProgrammingKeyboardType = /*#__PURE__*/
function (_Icon) {
  _inherits(IconProgrammingKeyboardType, _Icon);
  function IconProgrammingKeyboardType(props) {
    var _this;
    _classCallCheck(this, IconProgrammingKeyboardType);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconProgrammingKeyboardType).call(this, props));
    _this.name = 'IconProgrammingKeyboardType';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "programming-keyboard-type_svg__group0"
    }, _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path0",
      d: "M21.111 11.25a.5.5 0 010-1h1.219a.501.501 0 00.485-.622l-1.5-6a.5.5 0 00-.485-.378H3.391a.5.5 0 00-.485.379l-1.5 6a.503.503 0 00.131.475c.094.095.22.147.354.147h1.22a.5.5 0 010 1h-1.22c-.401 0-.777-.156-1.061-.439a1.49 1.49 0 01-.394-1.425l1.5-6A1.497 1.497 0 013.391 2.25H20.83c.689 0 1.287.467 1.455 1.135l1.5 6c.098.389.038.792-.168 1.136a1.49 1.49 0 01-1.287.729h-1.219z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path1",
      d: "M3.611 9.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path2",
      d: "M5.611 7.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path3",
      d: "M8.611 7.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path4",
      d: "M11.611 7.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path5",
      d: "M14.611 7.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path6",
      d: "M17.611 7.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path7",
      d: "M5.611 5.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path8",
      d: "M8.611 5.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path9",
      d: "M11.611 5.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path10",
      d: "M14.611 5.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path11",
      d: "M17.611 5.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path12",
      d: "M6.611 9.25a.5.5 0 010-1h11a.5.5 0 010 1h-11z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path13",
      d: "M19.611 9.25a.5.5 0 010-1h1a.5.5 0 010 1h-1z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path14",
      d: "M8.687 21.25a.498.498 0 01-.35-.856c1.002-.983 2.051-2.161 2.168-2.292a.474.474 0 01.065-.062.106.106 0 00.04-.075.113.113 0 00-.138-.123l-1.695 1.124a.502.502 0 01-.571-.013.504.504 0 01-.186-.541l1.4-4.915a.27.27 0 00-.255-.349.261.261 0 00-.25.182l-.007.02c-.003.009-.006.019-.011.029l-.832 2.918a.501.501 0 01-.962-.275l.841-2.949a.252.252 0 01.01-.029l.274-.955a.263.263 0 00-.024-.203.264.264 0 00-.234-.138.26.26 0 00-.129.034.263.263 0 00-.127.16l-.28.984-.843 2.949a.502.502 0 01-.616.344.501.501 0 01-.345-.619l.841-2.942a.272.272 0 00-.198-.316.272.272 0 00-.32.178l-1.046 3.67a.503.503 0 01-.615.344.498.498 0 01-.347-.619l.631-2.211a.267.267 0 00-.513-.146l-1.4 4.915c-.19.66-.04 1.366.401 1.89a.5.5 0 11-.764.645 3.045 3.045 0 01-.598-2.811l1.4-4.913a1.269 1.269 0 011.563-.871c.086.024.17.059.249.102l.081-.285a1.275 1.275 0 011.52-.857c.106.026.207.066.301.118.111-.247.298-.45.539-.584a1.278 1.278 0 01.964-.111c.6.172.975.75.912 1.35a1.257 1.257 0 011.047.661c.161.298.197.64.101.964l-1.028 3.608.612-.406a.493.493 0 01.066-.037 1.111 1.111 0 011.573 1.132 1.11 1.11 0 01-.373.716 53.621 53.621 0 01-2.194 2.318.476.476 0 01-.348.148z"
    }), _react2.default.createElement("path", {
      className: "programming-keyboard-type_svg__path15",
      d: "M15.534 21.25a.497.497 0 01-.35-.143 53.786 53.786 0 01-2.194-2.318 1.11 1.11 0 01-.135-1.534 1.11 1.11 0 011.335-.314.496.496 0 01.068.038l.613.406-1.03-3.615a1.255 1.255 0 01.102-.959 1.263 1.263 0 011.052-.661 1.27 1.27 0 011.258-1.375c.496 0 .938.284 1.146.721a1.267 1.267 0 011.818.721l.08.279a1.286 1.286 0 01.598-.15 1.266 1.266 0 011.226.958l1.396 4.898a3.045 3.045 0 01-.599 2.809.5.5 0 11-.765-.645c.441-.524.592-1.23.402-1.889l-1.411-4.953a.266.266 0 00-.506.167l.635 2.226a.496.496 0 01-.48.637.503.503 0 01-.481-.362l-1.051-3.686c-.031-.096-.135-.169-.252-.169a.267.267 0 00-.258.333l.839 2.933a.502.502 0 01-.482.637.501.501 0 01-.48-.363l-.843-2.949-.28-.985a.263.263 0 00-.314-.161.268.268 0 00-.194.324l.262.917v-.001a.14.14 0 01.012.029l.849 2.972a.502.502 0 01-.481.637.503.503 0 01-.481-.362l-.831-2.908a.43.43 0 01-.017-.044l-.01-.033a.261.261 0 00-.32-.155.263.263 0 00-.158.129.261.261 0 00-.021.203l1.402 4.921a.503.503 0 01-.481.637.5.5 0 01-.276-.083l-1.697-1.123a.116.116 0 00-.114.039.113.113 0 00.018.159.485.485 0 01.062.059c.196.22 1.202 1.344 2.17 2.294a.499.499 0 01-.351.857z"
    })));
    return _this;
  }
  return IconProgrammingKeyboardType;
}(_Icon3.default);
exports.default = IconProgrammingKeyboardType;